import { React, Component } from 'utils';
import { App } from 'model';

export default class Slider extends Component {
	
	constructor(props)
	{
		super(props);

		this.state = {
			active: 1,
			count: props.data.length
		}
	}

	componentDidMount() {
		this.enqueueChangeSlide();
	}

	componentWillUnmount() {
		clearTimeout(this.timer);
	}

	enqueueChangeSlide() {
		this.timer = setTimeout(this.changeSlide, 2000);
	}

	changeSlide = () => {
		var { active, count } = this.state;

		active++;

		if(active >= count) {
			active = 0;
		}

		this.setState({ active });
		this.enqueueChangeSlide();
	}

	render() {
		var { data } = this.props;
		var { active } = this.state;

		var slides = data.map(function(item, index) {
			var css = ['slide'];

			if(index == active) {
				css.push('active');
			}
			
			var arrow = App.resourceUrl('job-board-arrow.svg');

			return <div key={ index } className={ css.join(' ') }>
				<div className="background">
					<img src={ arrow } />
					<img src={ arrow } />
					<img src={ arrow } />
				</div>
				<div className="info">
					<h5>{item.title}</h5>
					<div className="gray-text">
						{ item.location }, { App.formatShortDate(item.deadline)}
					</div>
				</div>
			</div>
		});

		return <div className="slides">
			{ slides }
		</div>
 	}

}


// WEBPACK FOOTER //
// ./src/modules/components/elements/slider.js